module Meevo.Model {
  export class SmartTileParameterTypes {
    public static stringType: string = 'String';
    public static numberType: string = 'Number';
    public static includedEmployees: string = 'IncludedEmployees';
    public static locations: string = 'Locations';
    public static locationGroup: string = 'LocationGroup';
    public static timePeriod: string = 'TimePeriod';
    public static salesType: string = 'SalesType';
    public static ticketCountType: string = 'TicketCountType';
    public static appointmentState: string = 'AppointmentState';
    public static shortcutType: string = 'ShortcutType';
    public static imageUrl: string = 'ImageUrl';
    public static menuShortcut: string = 'MenuShortcut';
    public static service: string = 'Service';
    public static multiSelect: string = 'MultiSelect';
    public static membershipType: string = 'ClientMembershipIndicatorStatus';
    public static serviceCategory: string = 'ServiceCategory';
    public static productCategory: string = 'ProductCategory';
      public static sort: string = 'Sort';
      public static booleanType: string = 'Boolean';
    public static rebookingType: string = 'RebookingType';
  }
}
